// extracted by mini-css-extract-plugin
export default {"signup":"signup_signup__T9hIB","mainimg":"signup_mainimg__HH3G+","login":"signup_login__ikrkL","main":"signup_main__oaLyv"};